import Header from "components/header";
import React from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import mixpanel from 'mixpanel-browser';


import { useNavigate } from "react-router-dom";
import { Button, Container, Divider, Grid, Icon } from "semantic-ui-react";

import tourExample from 'home/images/tourExample.png'


import cup_example from './cup_example.jpg'
import cup_thumbnail from './cup_thumbnail.jpg'

import draft_example from './draft_example.png'
import draft_example_thumbnail from './draft_example_thumbnail.jpg'

import gameExampleImg from './game_example.png'

import ingameImg from './ingame_img.jpeg'
import ingame_thumbnail from './ingame_thumbnail.jpg'

const Tutorial = () => {
    const navigate = useNavigate();

    const toTopClick = () => {
        window.scrollTo(0, 0);
    }

    mixpanel.track("Tutorial Visited")

    return (
        <div className="melee-wrapper">
            <Container className='regularText' style={{ paddingTop: 10 }}>
                <Header
                    helmet='Tutorial'
                    rightMenu={
                        <button
                            className="melee-inline-button"
                            onClick={() => navigate(-1)}
                        >
                            Back
                        </button>}
                />
                <div className="page-header">
                    <h1><Icon name='student' style={{ marginRight: '.5em' }} />Tutorial</h1>
                </div>
                <Grid className='text-section' stackable>
                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <h2>Prerequisite</h2>
                            <ul>
                                <li>4-16 Players (recommended). More players requires more setup.</li>
                                <li>
                                    Beer (Bring 4.5l pr person, ~3l average consumed).
                                    We usually have a minimum 4.5% alcohol requirement.
                                </li>
                                <li>
                                    Plastic cups for every player, which holds at least 3dl.
                                    Measure and mark 1dl, 2dl and 3dl on the cup.
                                </li>
                            </ul>
                        </Grid.Column>
                        <Grid.Column>
                            <LazyLoadImage
                                alt={"Cup Example"}
                                placeholderSrc={cup_thumbnail}
                                src={cup_example}
                                effect='blur'
                            />
                        </Grid.Column>
                    </Grid.Row>

                    <Divider />

                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <LazyLoadImage
                                alt={"Draft Example"}
                                placeholderSrc={draft_example_thumbnail}
                                src={draft_example}
                                effect='blur'
                            />
                        </Grid.Column>
                        <Grid.Column>
                            <h2>Drafting</h2>
                            <ul>
                                <li>Follow the instructions stated at the bottom of the screen.</li>
                                <li>
                                    When a team is buying an item, <b>both</b> players have to drink
                                    the required amount. The drinking must finish before clicking "Purchase".
                                </li>
                                <li>
                                    E.g Even though <b>Re-Roll</b> only affects one player on the team, both players
                                    have to drink <b>3dl</b> beer
                                </li>
                            </ul>
                        </Grid.Column>
                    </Grid.Row>

                    <Divider />

                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <h2>In-game</h2>
                            <ul>
                                <li>Before the match begins, all players must fill their cup with <b>2dl</b></li>
                                <li>
                                    The beer have to be finished before the match ends
                                </li>
                                <li>
                                    It's not allowed to drink until <em>First Blood</em>. (An arbitrary player looses a stock)
                                </li>
                                <li>
                                    After first blood, there are no restrictions when to drink. It's a common strategy
                                    to drink after losing a stock
                                </li>
                                <li>
                                    If a player still has beer in their cup after losing all stocks, their team instantly loses
                                </li>
                                <li>
                                    If a team is winning the game, but have not finished their beer, it's considered a loss
                                </li>
                                <li>
                                    Every remaining beer is scored <b>-2 Stock</b>
                                </li>
                            </ul>
                        </Grid.Column>
                        <Grid.Column>
                            <LazyLoadImage
                                alt={"In-game Example"}
                                placeholderSrc={ingame_thumbnail}
                                src={ingameImg}
                                effect='blur'
                            />
                        </Grid.Column>
                    </Grid.Row>

                    <Divider />

                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <LazyLoadImage
                                alt={"Game Example"}
                                src={gameExampleImg}
                                effect='blur'
                            />
                        </Grid.Column>
                        <Grid.Column>
                            <h2>Tournament management</h2>
                            <ul>
                                <li>Click <b>Draft!</b> to instantly start a draft for the current game</li>
                                <li>After the draft is finished, clicking <b>Save</b> takes you back to the current game,
                                    and you'll be able to see the draft result at the game screen
                                </li>
                                <li>Click on either team to assign a winner</li>
                                <li>Type in the stock difference. E.g. if the winning team has a total of 3 stocks remaining, the stock difference should be 3</li>
                                <li>Protip: You can search on player names to filter relevant games.</li>
                            </ul>
                        </Grid.Column>
                    </Grid.Row>

                    <Divider />

                    <Grid.Row columns={2}>
                        <Grid.Column>
                            <h2>Finals</h2>
                            <p>
                                No official finals-system have been implement (yet). We usually divide the players into teams
                                based on the group stage results. The two bottom players form a team, and the 2 next players form a team etc.
                                Starting from the bottom, the bottom team meets the second bottom team. The winner meets the third bottom team, up until
                                grand finals.
                            </p>

                        </Grid.Column>
                        <Grid.Column>
                            <LazyLoadImage
                                alt={"Tournament Example"}
                                src={tourExample}
                                effect='blur'
                            />
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row column={1} style={{margin: '4em 0px 4em 0px'}}>
                        <div style={{textAlign: 'center', margin: 'auto'}}>
                            <Button onClick={() => toTopClick()}
                                basic
                                icon className='melee'
                                labelPosition='left'
                                size='large'
                            >
                                <Icon name='arrow up' />
                                To the top
                            </Button>
                        </div>
                    </Grid.Row>
                </Grid>

            </Container>
        </div>
    )
}

export default Tutorial;